module.exports = __webpack_public_path__ + "static/media/drizzle.90bce1a6.gif";